import React, { useState } from 'react';
import api from '../api/axios';
import { FaChartBar, FaCalculator } from 'react-icons/fa';

const TaxReport = () => {
  const [profit, setProfit] = useState('');
  const [report, setReport] = useState(null);
  const [message, setMessage] = useState('');

  const handleCalculate = async () => {
    try {
      const payload = { annual_profit: Number(profit) };
      const res = await api.post('/tax/report', payload);
      setReport(res.data);
      setMessage('');
    } catch (err) {
      console.error(err);
      setMessage('Error calculating tax');
      setReport(null);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      {/* Page Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '24px',
      }}>
        <div style={{
          width: '42px',
          height: '42px',
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #00aaff, #0077cc)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: '18px',
        }}>
          <FaChartBar />
        </div>
        <div>
          <h4 style={{ margin: 0, color: '#1a1a2e', fontWeight: '600' }}>Corporate Tax Report</h4>
          <p style={{ margin: 0, fontSize: '13px', color: '#888' }}>Calculate corporate tax based on annual profit</p>
        </div>
      </div>

      {/* Input Card */}
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        border: '1px solid #e0f0ff',
        padding: '28px',
        maxWidth: '600px',
        boxShadow: '0 2px 12px rgba(0, 119, 204, 0.06)',
        marginBottom: '20px',
      }}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            marginBottom: '6px',
            fontWeight: '500',
            color: '#333',
            fontSize: '14px',
          }}>
            Annual Profit (AED)
          </label>
          <input
            type="number"
            value={profit}
            onChange={(e) => setProfit(e.target.value)}
            placeholder="Enter annual profit amount"
            style={{
              width: '100%',
              padding: '10px 14px',
              borderRadius: '8px',
              border: '1px solid #d0e8ff',
              background: '#f8fbff',
              color: '#333',
              fontSize: '14px',
              outline: 'none',
              transition: 'border-color 0.2s',
            }}
            onFocus={(e) => e.target.style.borderColor = '#00aaff'}
            onBlur={(e) => e.target.style.borderColor = '#d0e8ff'}
          />
        </div>

        <button
          onClick={handleCalculate}
          style={{
            background: 'linear-gradient(135deg, #00aaff, #0077cc)',
            border: 'none',
            color: '#fff',
            padding: '10px 24px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.opacity = '0.9'}
          onMouseLeave={(e) => e.target.style.opacity = '1'}
        >
          <FaCalculator /> Calculate Tax
        </button>

        {message && (
          <div style={{
            marginTop: '16px',
            padding: '10px 14px',
            borderRadius: '8px',
            background: '#fff0f0',
            color: '#d32f2f',
            border: '1px solid #ffc5c5',
            fontSize: '14px',
            fontWeight: '500',
          }}>
            {message}
          </div>
        )}
      </div>

      {/* Result Card */}
      {report && (
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          border: '1px solid #e0f0ff',
          padding: '24px',
          maxWidth: '600px',
          boxShadow: '0 2px 12px rgba(0, 119, 204, 0.06)',
        }}>
          <h6 style={{
            color: '#0077cc',
            fontWeight: '600',
            marginBottom: '16px',
            paddingBottom: '10px',
            borderBottom: '1px solid #e0f0ff',
          }}>
            Tax Calculation Result
          </h6>

          {[
            { label: 'Annual Profit', value: `${report.annual_profit ?? profit} AED` },
            { label: 'Tax Threshold', value: `${report.threshold_limit} AED` },
            { label: 'Taxable Amount', value: `${report.taxable_amount} AED` },
            { label: 'Tax Percentage', value: `${report.tax_percentage}%` },
            { label: 'Corporate Tax', value: `${report.corporate_tax} AED`, highlight: true },
          ].map((item, i) => (
            <div key={i} style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '10px 0',
              borderBottom: i < 4 ? '1px solid #f0f7ff' : 'none',
            }}>
              <span style={{
                color: '#555',
                fontSize: '14px',
                fontWeight: item.highlight ? '600' : '400',
              }}>
                {item.label}
              </span>
              <span style={{
                color: item.highlight ? '#0077cc' : '#1a1a2e',
                fontWeight: '600',
                fontSize: item.highlight ? '16px' : '14px',
              }}>
                {item.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TaxReport;
